import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArticleIcon from '@mui/icons-material/Article'; // file
import LinkIcon from '@mui/icons-material/Link'; // link
import MenuBookIcon from '@mui/icons-material/MenuBook'; // content
import AssignmentIcon from '@mui/icons-material/Assignment'; // assignment
import QuizIcon from '@mui/icons-material/Quiz'; // onlinetest
import ArrowRightIcon from '@mui/icons-material/ArrowRight'; // module
import moment from 'moment';
interface LockedItem {
  type: 'file' | 'link' | 'content' | 'assignment' | 'onlinetest' | 'module';
  item_name: string;
  id: string;
}
interface LockedDialogProps {
  open: boolean;
  onClose: () => void;
  items: {lockData?: LockedItem[]; chapterTitle: string; lockDate?: string};
}

const UnLockedDialog: React.FC<LockedDialogProps> = ({open, onClose, items}) => {
  const getIconForType = (type: LockedItem['type']) => {
    switch (type) {
      case 'file':
        return <ArticleIcon />;
      case 'link':
        return <LinkIcon />;
      case 'content':
        return <MenuBookIcon />;
      case 'assignment':
        return <AssignmentIcon />;
      case 'onlinetest':
        return <QuizIcon />;
      case 'module':
        return <ArrowRightIcon />;
      default:
        return <ArticleIcon />;
    }
  };
  const itemLength = items?.lockData?.length || 0;
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        {items.chapterTitle} is unlocked
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{position: 'absolute', right: 8, top: 8}}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{pb: 2}}>
        {itemLength !== 0 && (
          <DialogContentText sx={{mb: 1}}>
            The following is completed and unlocked:
          </DialogContentText>
        )}
        <List>
          {items?.lockData &&
            items?.lockData.length > 0 &&
            items?.lockData.map((item, index) => (
              <React.Fragment key={item.id}>
                <ListItem>
                  <ListItemIcon>{getIconForType(item.type)}</ListItemIcon>
                  <ListItemText primary={item.item_name} />
                </ListItem>
                {index < itemLength - 1 && <Divider />}
              </React.Fragment>
            ))}
          {itemLength === 0 && (
            <ListItem>
              <ListItemText
                primary={`The entity will is unlocked on: ${moment(
                  items.lockDate
                ).format('DD/MM/YYYY')}`}
              />
            </ListItem>
          )}
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default UnLockedDialog;
